import officeCelebration from '../../assests/images/officeCelebration.jpg'

export default function BeliefSection() {
  return (
    <section className="relative">
      <img
        src={officeCelebration}
        alt="Team celebration"
        className="w-full h-[420px] object-cover"
      />

      <div className="absolute inset-0 bg-[#92abc4]/80 flex flex-col items-center justify-center text-center px-4">
        <h2 className="text-white text-4xl font-bold">
          WE BELIEVE IN RELATIONSHIPS
        </h2>

        <p className="text-white mt-4 text-lg">
  We aim to deliver{" "}
  <span className="text-yellow-400 font-serif text-2xl font-bold tracking-wide">
    delight
  </span>{" "}
  to your audience.
</p>
      </div>
    </section>
  );
}
